export const MENU_FIELD_LABELS = {
  name: "שם המנה",
  price: "מחיר",
  sizes: "גודל / משקל",
  desc: "תיאור",
};

export const MENU_EMPTY_PLACEHOLDERS = {
  sizes: "גודל / משקל (לא חובה)",
  desc: "תיאור המנה (לא חובה)",
};

export function createEmptyMenuItem() {
  return {
    name: "מנה חדשה",
    price: "0 ₪",
    sizes: "",
    desc: "",
  };
}
